import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectInvoice = state => {
    return selectOwnState(state).invoice
}




// WEBPACK FOOTER //
// ./src/modules/invoice/state/display/selector.js